import React, {
    useState,
    useEffect,
    useCallback
} from 'react';
import api from '../api';
import UserForm from '../components/UserForm';
import {
    Container,
    Typography,
    Alert,
    Collapse
} from '@mui/material';

const Profile = () => {
    const [formData, setFormData] = useState(null); // Initialize as null to show loading state
    const [loading, setLoading] = useState(true);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const fetchProfile = useCallback(async () => {
        setLoading(true);
        try {
            const response = await api.get('/api/accounts/profile/');
            const profileData = {
                ...response.data,
                job: response.data.job || null,
            };
            setFormData(profileData);
        } catch (error) {
            if (error.response) {
                console.error('Failed to fetch profile:', error.response.data);
            } else if (error.request) {
                console.error('Failed to fetch profile: No response from server.', error.request);
            } else {
                console.error('Failed to fetch profile: Error', error.message);
            }
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchProfile();
    }, [fetchProfile]);

    const handleSubmit = async (processedData) => {
        try {
            await api.put('/api/accounts/profile/', processedData);
            setSuccessMessage('Profile updated successfully!');
            setTimeout(() => setSuccessMessage(''), 5000); // Hide after 5 seconds
        } catch (error) {
            if (error.response) {
                console.error('Failed to update profile:', error.response.data);
                setErrorMessage('Failed to update profile. The server responded with this error: ' +
                    error.response?.data?.detail);
            } else if (error.request) {
                console.error('Failed to update profile: No response from server.', error.request);
                setErrorMessage('Failed to update profile. Check your connection.');
            } else {
                console.error('Failed to update profile: Error', error.message);
                setErrorMessage('An error occurred while updating the profile: ' + error.message);
            }
            setTimeout(() => setErrorMessage(''), 5000); // Hide after 5 seconds
        }
    };

    if (loading) {
        return <Typography>Loading...</Typography>;
    }

    return (
        <Container maxWidth="md">
            <UserForm
                formData={formData}
                setFormData={setFormData}
                handleSubmit={handleSubmit}
                isRegister={false}
                formTitle="Your Profile"
            />
            <Collapse in={!!successMessage}>
                <Alert severity="success" sx={{mt: 2}}>
                    {successMessage}
                </Alert>
            </Collapse>
            <Collapse in={!!errorMessage}>
                <Alert severity="error" sx={{mt: 2}}>
                    {errorMessage}
                </Alert>
            </Collapse>
        </Container>
    );
};

export default Profile;
